<div class="label_properties">
  <small class="debug">{{me}}</small>
  @if (dynamicsInitialized) {
    <div>
      <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
      </dynamic-form>
      <hr/>
      <app-font-selector #fontLoader (onChange)="onFontChanged($event, '', 'Label')" [setConfig]="{i_config: sceneItem}"></app-font-selector>
      <hr/>
    </div>
  }
</div>


